import { useRouter } from 'next/router';

//* Helpers
import { config } from 'helpers';

//* Components
import CustomLink from 'components/common/CustomLink';
import Text from 'components/common/Text';
import Image from 'components/common/Image';

//* Style
import RelatedBlogItemStyle from './style';

const RelatedBlogItem = ({ slug, featured_image, title, featured_description, tags, className, index }) => {
	const router = useRouter();

	return (
		<RelatedBlogItemStyle className={`rbp-item-cont ${className || ''}`}>
			<CustomLink
				url={slug}
				className='rbp-item primaryColor3-bg'
			>
				<Image
					objectFit={'cover'}
					src={featured_image?.url}
					alt={featured_image?.alt}
					priority={router.pathname == config.routes.articles.path ? index < 12 : false}
				/>

				<div className='rbp-item-info-cont'>
					<Text
						text={title}
						tag='h5'
						className='rbp-item-title font-ping-bolder h6'
					/>

					<Text
						text={featured_description}
						tag='h6'
						className='rbp-item-subtitle font-helvetica p pS'
					/>

					<div className='rbp-item-tags-cont'>
						{tags?.map((t, b) => (
							<Text
								key={b}
								text={`${t.name} `}
								tag='span'
								className='rbp-item-tag font-helvetica p pXS secondaryColor2'
							/>
						))}
					</div>
				</div>
			</CustomLink>
		</RelatedBlogItemStyle>
	);
};

export default RelatedBlogItem;
